import currencyJS from 'currency.js';
import Decimal from 'decimal.js';
import { Currency, currencySymbols } from '../locale';

/**
 * @deprecated Use `packages/shared/src/utils/round.ts` instead (more efficient)
 */
export const roundTo = (decimalPlaces: number) => (n: number) => parseFloat(n.toFixed(decimalPlaces));

/**
 * Helper to pad numbers to 2 decimal places (1 => 1.00)
 * @deprecated Use `formatNumber()` instead
 */
export const toCurrency = (number: number, imposeLocaleFormatting = false) => {
  if (imposeLocaleFormatting) {
    return number.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  } else {
    return roundTo(2)(number).toFixed(2);
  }
};

export const toDisplayPrice = (currencySymbol: string, price: number, imposeLocaleFormatting = true) => {
  return `${currencySymbol}${toCurrency(price, imposeLocaleFormatting)}`;
};

export const getTotalAmount = (items: { amount: number; quantity: number }[]) =>
  items.reduce((total, item) => total.add(currencyJS(item.amount).divide(100).multiply(item.quantity)), currencyJS(0));

export const penceToDisplayPrice = (pence: number, currency: Currency, imposeLocaleFormatting = true) => {
  const baseHundred = pence / 100;
  return toDisplayPrice(currencySymbols[currency], baseHundred, imposeLocaleFormatting);
};

/**
 * Converts pounds to pence, dollars to cents, etc, by multipling by 100.
 */
export const currencyInSmallestUnit = (currencyAmount: number) => Math.round(currencyAmount * 100);

export const toMinorCurrencyUnits = (amount: Decimal.Value): Decimal => new Decimal(amount).times(100);

export const toMajorCurrencyUnits = (amount: Decimal.Value): Decimal => new Decimal(amount).div(100);
